// import "@/mocks";

import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

dayjs.extend(utc);
dayjs.extend(timezone);
import "@app/styles/index.css";
import { App } from "@app/App";
import { registerAnalyticsRouter } from "@app/config/loggers/analyticsContext";
import { BaseLogger } from "@app/config/loggers/baseLogger";
import { initOfflineTracker } from "@app/config/loggers/offlineTracker";
import { PerformanceLogger } from "@app/config/loggers/performanceLogger";
import { router } from "@app/config/router";
import { initSentry } from "@app/config/sentry";
import { onCLS, onINP, onLCP } from "web-vitals";

initSentry();

BaseLogger.init();
// 라우트 패턴은 이벤트 시점에 라우터에서 직접 읽으므로, 첫 이벤트보다 먼저 등록해 둔다.
registerAnalyticsRouter(router);
initOfflineTracker();
PerformanceLogger.initLongTaskObserver();
PerformanceLogger.sampleStorage();

onLCP(PerformanceLogger.logVitals);
onINP(PerformanceLogger.logVitals);
onCLS(PerformanceLogger.logVitals);

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
